<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="document" slot-scope="{ item }">
            <div v-if="!isVigilance">{{ item.document }}</div>
            <div v-else>Dato protegido</div>
        </template>
        <template slot="email" slot-scope="{ item }">
            <div v-if="!isVigilance">{{ item.email }}</div>
            <div v-else>Dato protegido</div>
        </template>
        <template slot="phone" slot-scope="{ item }">
            <div v-if="!isVigilance">{{ item.phone }}</div>
            <div v-else>Dato protegido</div>
        </template>
        <template slot="arl" slot-scope="{ item }">
            <div v-if="!isVigilance">{{ !!item.arl ? item.arl.name : '' }}</div>
            <div v-else>Dato protegido</div>
        </template>

        <template slot="structure.name" slot-scope="{ item }">
            {{
                !!item.structure
                    ? `${item.structure.name} / ${
                          !!item.structure.venue
                              ? item.structure.venue.name
                              : ''
                      }`
                    : ''
            }}
        </template>
        <template slot="internal" slot-scope="{ item }">
            <div v-if="item.internal">SI</div>
            <div v-else>NO</div>
        </template>
        <template slot="photo" slot-scope="{ item }">
            <div
                class="col-12 col-sm-6 avatar"
                v-if="!!item.photo"
                :style="`background-image: URL(${item.photo})`"
            ></div>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" @click="seeCard(item)"
                ><i class="fa fa-search-plus"></i
            ></b-button>
            <b-button variant="primary" size="sm" @click="updatePerson(item)"
                ><i class="fa fa-pencil" aria-hidden="true"></i
            ></b-button>
            <b-button variant="danger" size="sm" @click="removePerson(item)"
                ><i class="fa fa-trash-o" aria-hidden="true"></i
            ></b-button>
            <b-btn
                variant="primary"
                size="sm"
                v-if="!!item.internal"
                @click="sendQrAccessCode(item)"
                ><i class="fa fa-qrcode" aria-hidden="true"></i
            ></b-btn>
        </template>
    </app-data-table>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        seeCard: {
            type: Function,
            required: true,
        },
        updatePerson: {
            type: Function,
            required: true,
        },
        removePerson: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            fields,
            isVigilance: false,
        }
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        async sendQrAccessCode(person) {
            try {
                const { data } = await repo.post(
                    `people/${person.id}/send-qr-code`
                )

                !!data.status && toastr.success('Código QR enviado')
            } catch (err) {
                toastr.error('Ocurrió un error al enviar el código QR')
            }
        },
    },
    created() {
        this.isVigilance = this.user.profile.slug === 'vigilante' ? true : false
    },
}

const fields = [
    {
        key: 'name',
        label: 'Nombre',
    },
    {
        key: 'structure.name',
        label: 'Estructura / Sede',
    },
    {
        key: 'document',
        label: 'Documento',
    },
    {
        key: 'email',
        label: 'E-mail',
    },
    {
        key: 'position',
        label: 'Posición / Cargo',
    },
    {
        key: 'arl',
        label: 'ARL',
    },
    {
        key: 'phone',
        label: 'Teléfono',
    },
    {
        key: 'internal',
        label: 'Interno',
    },
    {
        key: 'notes',
        label: 'Notas',
    },
    {
        key: 'photo',
        label: 'Foto',
        sortable: false,
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
